module.exports = __webpack_public_path__ + "static/modify-machine-5825c47bd8d9bc569577a19d2fb05793.png";